export const isFutureDate = (date) => {
    const today = new Date().getTime();
    const future = new Date(date).getTime();
    return future > today;
};